var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74154 19.2692L17.0235 12.4071C17.2314 12.2113 17.3455 11.9502 17.3455 11.6718C17.3455 11.3931 17.2312 11.1322 17.0235 10.9363L16.3622 10.3133C16.1547 10.1176 15.8775 10.0098 15.5819 10.0098C15.2865 10.0098 14.9999 10.1176 14.7924 10.3133L10.535 14.3165L10.535 1.59818C10.535 1.02475 10.0586 0.571655 9.44991 0.571655L8.51501 0.571655C7.90634 0.571655 7.38192 1.02474 7.38192 1.59817L7.38192 14.3619L3.10071 10.3135C2.89285 10.1178 2.62318 10.0099 2.32761 10.0099C2.03237 10.0099 1.75877 10.1178 1.55107 10.3135L0.89191 10.9365C0.684045 11.1324 0.57077 11.3933 0.57077 11.672C0.57077 11.9503 0.68552 12.2114 0.893384 12.4073L8.17518 19.2693C8.3837 19.4657 8.66205 19.5736 8.95795 19.5729C9.25483 19.5735 9.53335 19.4657 9.74154 19.2692Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrowDown);
export default __webpack_public_path__ + "static/media/ScrollArrowDown.0c6150659edde5473108dcb11072f40a.svg";
export { ForwardRef as ReactComponent };